import { useState } from 'react'
import { LikutModals } from '../../../../../modules/Context/CefiNum'
import ModalContainer from './ModalContainer'

const INITIAL_RESON_STATE = {
    resonTag: null,
    action: null,
    active: false,
    props: {}
}

const LikutModalsProvider = ({ children }) => {
    const [resonState, setResonState] = useState(INITIAL_RESON_STATE)
    return (
        <LikutModals.Provider value={[resonState, setResonState]}>
            <ModalContainer />
            {children}
        </LikutModals.Provider>
    )
}

export default LikutModalsProvider
